import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Calendar
//Chat
import chatReducer from "./chat/reducer";
//Ecommerce

//Project



//Invoice

//Mailbox

// Dashboard Analytics


// Dashboard Ecommerce


// Pages > Team



// File Manager

// To do

// Job

// API Key
import APIKeyReducer from "./apiKey/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Chat: chatReducer,

    

    APIKey: APIKeyReducer
});

export default rootReducer;